import { useCallback, useEffect, useRef, useState } from 'react';
import { authApi } from './auth';
import { SESSION_EVENT, SESSION_STORAGE_KEY } from './sessionEvents';

const visitor = {team:false,admin:false,workspaces:[],mode:null,role:'visitor'};

export function useSession(area) {
  const [state,setState]=useState({area:null,principal:null});
  const sequence=useRef(0),lastPrincipal=useRef(null),flight=useRef(null);
  const refresh=useCallback((block=false,force=true)=>{
    if(!force&&flight.current?.area===area)return flight.current.promise;
    flight.current?.controller.abort();
    const request=++sequence.current;
    const controller=new AbortController();
    if(block)setState({area,principal:null});
    const promise=(async()=>{
    let principal;
    try { principal=await authApi.me(controller.signal); } catch { principal={...visitor,session_unavailable:true}; }
    // A pre-login/old-route response must never restore permissions after a
    // newer request. Server-side scope checks remain the authority.
    if(request===sequence.current){
      if(!principal.team&&!principal.session_unavailable&&(lastPrincipal.current?.team||lastPrincipal.current?.session_expired))principal={...principal,session_expired:true};
      if(!principal.session_unavailable)lastPrincipal.current=principal;
      setState({area,principal});
    }
    return principal;
    })().finally(()=>{if(flight.current?.request===request)flight.current=null;});
    flight.current={area,request,controller,promise};
    return promise;
  },[area]);
  useEffect(()=>{
    refresh(true);
    const changed=()=>{lastPrincipal.current=null;refresh(true);},focus=()=>refresh(false,false);
    const storage=e=>{if(e.key===SESSION_STORAGE_KEY)changed();};
    const visibility=()=>{if(document.visibilityState==='visible')focus();};
    const pageshow=e=>{if(e.persisted)refresh(true);};
    const timer=setInterval(()=>{if(document.visibilityState==='visible')refresh(false,false);},15000);
    window.addEventListener(SESSION_EVENT,changed);window.addEventListener('storage',storage);
    window.addEventListener('focus',focus);window.addEventListener('pageshow',pageshow);
    document.addEventListener('visibilitychange',visibility);
    return()=>{
      sequence.current++;flight.current?.controller.abort();flight.current=null;clearInterval(timer);window.removeEventListener(SESSION_EVENT,changed);
      window.removeEventListener('storage',storage);window.removeEventListener('focus',focus);
      window.removeEventListener('pageshow',pageshow);document.removeEventListener('visibilitychange',visibility);
    };
  },[refresh]);
  return {me:state.area===area?state.principal:null,refresh};
}